import { render, staticRenderFns } from "./Journeys.vue?vue&type=template&id=65ee7c20&scoped=true&"
import script from "./Journeys.vue?vue&type=script&lang=js&"
export * from "./Journeys.vue?vue&type=script&lang=js&"
import style0 from "./Journeys.vue?vue&type=style&index=0&id=65ee7c20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ee7c20",
  null
  
)

export default component.exports